export const CHANGE_CATEGORY_RANK = 'category/CHANGE_RANK';

export const changeCategoryRank = (categoryId, rank) => ({
  type: CHANGE_CATEGORY_RANK,
  payload: {
    categoryId,
    rank,
  },
});
